
import TransformModel from '../../designer/diagrams/TransformModel';
import PropertyDescriptor from '../../designer/utils/PropertyDescriptor';

export default class Model extends TransformModel {


    constructor(opts = {}) {
        super();
        this.scripts.enabled = false;
        this.dataContext.enabled = false;
        this.dataSources.enabled = false;
        this.events.enabled = false;
        this.messages.enabled = false;
        this.layoutMode.enabled = false;
        this.zIndex.enabled = false;
        this.margin.enabled = false;
        this.padding.enabled = false;
        this.isEdit.enabled = false;
        this.hidden.enabled = false;
    }
}
